module.exports = __webpack_public_path__ + "images/file_icons_v2/svg-8fb0daa1dee100f1b10a07cfc2d157e6.svg";